import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { baselineActions } from 'store';
import { AccordionFullTable, AddCircleBlue, CustomDelete } from 'components';
import { PermissionList, RolePermission, sortListByKey, useModal } from 'utils';
import { baselineTableInfo } from './constants';
import { AddBaseline } from './addBaseline';
import { EditBaseline } from './editBaseline';

const DELETE_ACTION_TYPE = 'DELETE_BASELINE_SESSION';
export const Baseline = ({ target }) => {
    const canCollectData = RolePermission([PermissionList.GOAL_CREATE?.code]);
    const goalById = useSelector((state) => state.goals.goalById);
    const baselineList = useSelector((state) => state.baselines.baselineList);
    const [selectedIndex, setSelectedIndex] = useState('');
    const { open } = useModal();
    const dispatch = useDispatch();
    const [sendParams, setSendParams] = useState({});
    const renderParams = () => {
        const sendInfo = {
            ...sendParams,
        };
        delete sendInfo.page;
        delete sendInfo.limit;
        delete sendInfo.skip;
        delete sendInfo.tabType;
        return sendInfo;
    };

    useEffect(() => {
        getBaselines();
    }, [sendParams]);

    const getBaselines = (load) => {
        dispatch(baselineActions.getBaselines({ targetId: target?.id, ...renderParams() }, load));
    };

    const handleAction = (name, item, parent) => {
        if (name === 'edit') {
            open(<EditBaseline currentItem={item} target={target} afterSuccess={() => getBaselines('noLoad')} />);
        }
        if (name === 'editTrial') {
            open(
                <AddBaseline
                    currentItem={{ ...item, baselineId: parent?.id }}
                    target={target}
                    afterSuccess={() => getBaselines('noLoad')}
                />
            );
        }
        if (name === 'createSession') {
            open(<AddBaseline fromTrial={item} target={target} afterSuccess={() => getBaselines('noLoad')} />);
        }
        if (name === 'deleteTrial') {
            open(
                <CustomDelete
                    info="Are you sure you want to delete this session?"
                    text="Once deleted, this session will be permanently lost."
                    handleDel={() => dispatch(baselineActions.deleteBaselineSession(parent?.id, item?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    afterSuccess={() => getBaselines('noLoad')}
                />
            );
        }
    };

    return (
        <div>
            <div className="header-action-btn">
                {canCollectData && (
                    <AddCircleBlue
                        text={'Add New Baseline'}
                        handleClick={() => open(<AddBaseline target={target} afterSuccess={() => getBaselines('noLoad')} />)}
                    />
                )}
            </div>
            <AccordionFullTable
                getParams={(ev) => setSendParams(ev)}
                savedParams={sendParams}
                margin={'0'}
                tableInfo={baselineTableInfo(selectedIndex, handleAction, goalById, canCollectData)}
                list={sortListByKey(baselineList?.data, 'status', sendParams)}
                handleAccordion={(index) => setSelectedIndex(index)}
            />
        </div>
    );
};
